import React from 'react'
import { IconProps } from './interfaces/IconProps.interface'

const ShieldUserFill = (props: IconProps) => {
    const { color = "#000", ...rest } = props

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <g clipPath="url(#clip0_10103_6417)">
                <path d="M2.522 1.88384L8 0.666504L13.478 1.88384C13.626 1.91675 13.7584 1.99915 13.8533 2.11744C13.9482 2.23573 14 2.38285 14 2.5345V9.1925C14 9.85099 13.8373 10.4993 13.5266 11.0798C13.2158 11.6604 12.7666 12.1553 12.2187 12.5205L8 15.3332L3.78133 12.5205C3.23352 12.1553 2.78431 11.6606 2.47357 11.0801C2.16282 10.4997 2.00016 9.85155 2 9.19317V2.5345C2.00003 2.38285 2.05176 2.23573 2.14666 2.11744C2.24156 1.99915 2.37396 1.91675 2.522 1.88384V1.88384ZM8 7.33317C8.44203 7.33317 8.86595 7.15758 9.17851 6.84502C9.49107 6.53245 9.66667 6.10853 9.66667 5.6665C9.66667 5.22448 9.49107 4.80055 9.17851 4.48799C8.86595 4.17543 8.44203 3.99984 8 3.99984C7.55797 3.99984 7.13405 4.17543 6.82149 4.48799C6.50893 4.80055 6.33333 5.22448 6.33333 5.6665C6.33333 6.10853 6.50893 6.53245 6.82149 6.84502C7.13405 7.15758 7.55797 7.33317 8 7.33317ZM5.018 10.6665H10.982C10.9012 9.9321 10.5522 9.25335 10.0019 8.76032C9.45168 8.26728 8.73883 7.99464 8 7.99464C7.26117 7.99464 6.54832 8.26728 5.99805 8.76032C5.44779 9.25335 5.09881 9.9321 5.018 10.6665V10.6665Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_10103_6417">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default ShieldUserFill